import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import * as constants from '../constants';

import {isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet} from 'react-device-detect';

import logo1 from '../assets/cdn_img/logo-1.508ab220deeda71b5d14.png';
import no_user_explurger from '../assets/img/no-user-explurger-3x.png';
import closeIcon from '../assets/icon/close-button.png';

// A Bootstrap-based replica of the Explurger "Page not found" screen
// with the centered promo modal from your screenshots.
export default function ExplurgerPageNotFoundMock() {
  const [showModal, setShowModal] = useState(true);
  const [dontMissModel, setDontMissModel] = useState(true);
  
    useEffect(() => {
        const handleLinkClick = (e) => {
            const link = e.target.closest("a"); // catch <a> even if child element clicked
            // Deep-Link-Open
            //console.log(link, link.getAttribute("class"));
            if(link && link.getAttribute("href") && link.getAttribute("class") == "Deep-Link-Open")
            {

            }
            else if (link && link.getAttribute("href")) {
                e.preventDefault(); // stop default navigation
                //const url = link.getAttribute("href");

                //console.log("Intercepted link:", url);

              var url = constants.APP_WEBSITE_URL;
              if((isMobile || isTablet) && isAndroid)
              {
                  url = constants.APP_GOOGLE_PLAY_URL;
              }
              else if((isMobile || isTablet) && isIOS)
              {
                  url = constants.APP_APPLE_APP_STORE_URL;
              }                
              window.open(url);                

            }
        };

        document.addEventListener("click", handleLinkClick);
        return () => document.removeEventListener("click", handleLinkClick);
    }, []);   

    const getTheExplurgerAppNow = () => {
      //console.log("CommonComponent-getTheExplurgerAppNow ");
      //isMobile, isAndroid, isIOS, isWinPhone
      //console.log(isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet);
      var url = constants.APP_WEBSITE_URL;
      if((isMobile || isTablet) && isAndroid)
      {
          url = constants.APP_GOOGLE_PLAY_URL;
      }
      else if((isMobile || isTablet) && isIOS)
      {
          url = constants.APP_APPLE_APP_STORE_URL;
      }                
      window.open(url);
  } 

  return (
    <div className="bg-light text-black min-vh-100 d-flex flex-column">
      {/* Top bar */}
      {/* <header className="border-bottom border-secondary py-3 px-3 d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <span className="fs-5 fw-semibold">Explurger</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <a className="text-decoration-none link-light me-2" href="#">Log in</a>
          <button className="btn btn-primary btn-sm">Open app</button>
        </div>
      </header> */}

      {/* Body */}
      <main className="container flex-fill d-flex flex-column align-items-center justify-content-start text-center py-5">
        <h1 className="display-6 fw-bold mt-5">Sorry, this page isn't available.</h1>
        <p className="text-secondary fs-5 mt-3" style={{maxWidth: 428}}>
          The link you followed may be broken, or the page may have been removed.{' '}
          <br></br><br></br>
          <img src={no_user_explurger} ></img>
          <br></br><br></br>
          <a className="link-primary text-decoration-none" href="https://www.explurger.com/">Go back to Explurger.</a>
        </p>
      </main>

      {/* Footer */}
      <footer className="container text-center text-secondary small py-4">
        <div className="d-flex flex-wrap justify-content-center gap-3">
          {["Explurger","About Us","Features","Trending","Testimonials","Blog","News","Contact","Privacy","Terms"].map((label) => (
            <a key={label} href="#" className="text-decoration-none link-secondary">{label}</a>
          ))}
        </div>
        <div className="mt-2">© <span className="CurrentYear">{new Date().getFullYear()}</span> Explurger</div>
      </footer>

      {/* Promo Modal (custom-bootstrap mix) */}
      {showModal && (
        <div className="position-fixed top-0 start-0 w-100 h-100" style={{background:"rgba(0,0,0,.65)", zIndex: 1050}}>
          <div className="d-flex w-100 h-100 align-items-center justify-content-center p-3">
            <div className="bg-white text-black rounded-4 shadow-lg" style={{maxWidth: 428, width: "100%"}}>
              <div className="position-relative">
                <img src={closeIcon} alt="close" className="position-absolute pageNotFoundCloseIcon closeIconStyle" onClick={() => setShowModal(false)} />
                {/* <button
                  aria-label="Close"
                  className="btn btn-outline-dark position-absolute end-0 me-3 mt-3 rounded-circle p-2"
                  style={{opacity:.9}}
                  onClick={() => setShowModal(false)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-black">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button> */}
              </div>

              <div className="p-4 p-md-5">
                {/* Logo */}
                <div className="d-flex justify-content-center mb-4">
                  <a href="https://www.explurger.com/">
                    <img src={logo1} alt="Explurger Logo" className="header-logo"></img>
                  </a>

                  {/* <div className="rounded-4 p-3" style={{background:"linear-gradient(135deg,#FFDC80,#FCAF45,#F77737,#F56040,#FD1D1D,#E1306C,#C13584,#833AB4,#5851DB)", width: 96, height: 96, display:'grid', placeItems:'center'}}>
                    <div className="bg-black rounded-3" style={{width: 72, height: 72, display:'grid', placeItems:'center'}}>
                      <div className="border border-2 rounded-circle" style={{width: 36, height: 36}}/>
                    </div>
                  </div> */}

                </div>

                <h3 className="fw-bold text-center">Get the full experience</h3>
                <p className="text-secondary text-center fs-5 mb-4" style={{maxWidth:428, margin:"0 auto"}}>
                  Enjoy more photos and videos in the Explurger app.
                </p>

                <p className="text-secondary text-center mb-4" style={{maxWidth:428, margin:"0 auto"}}>
                  By continuing, you agree to Explurger's <br></br><a href="#" className="link-secondary text-secondary-emphasis">Terms of Use</a> and <a href="#" className="link-secondary text-secondary-emphasis">Privacy Policy</a>.
                </p>

                <div className="d-flex flex-column align-items-center gap-3">
                  {/* <button className="btn btn-primary btn-lg w-100" style={{maxWidth:520}}>Open Explurger</button> */}
                  {/* <button className="btn btn-link text-decoration-none link-light">Sign up</button> */}
                  
                  <button className='btn getTheAppCenetr' onClick={getTheExplurgerAppNow}>Get the Explurger app now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
